export const SIGNICAT_QUERY_PARAMS_ERRORS = {
	E_AUTHENTICATION_CHALLENGE_CUSTOMERABORTED: "E_AUTHENTICATION_CHALLENGE_CUSTOMERABORTED",
	E_AUTHENTICATION_CHALLENGE_INTERNALERROR: "E_AUTHENTICATION_CHALLENGE_INTERNALERROR",
};

export interface SignicatQueryParams {
	token?: string;
	error?: string;
}
